import { createTheme } from '@mui/material/styles';
import { tokens } from './tokens';

/**
 * Shared MUI theme built from design tokens. Applied once at the app root via
 * <ThemeProvider>. Existing pages that use `sx` with hardcoded colors keep
 * working; new code should prefer `theme.palette.*` / tokens.
 */
export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: tokens.color.brand,
      dark: tokens.color.brandDark,
      contrastText: '#ffffff',
    },
    secondary: {
      main: tokens.color.indigo,
      contrastText: '#ffffff',
    },
    success: { main: tokens.color.green },
    warning: { main: tokens.color.amber },
    error: { main: tokens.color.red },
    info: { main: tokens.color.brandAccent },
    background: {
      default: tokens.color.appBg,
      paper: tokens.color.surface,
    },
    text: {
      primary: tokens.color.textPrimary,
      secondary: tokens.color.textSecondary,
    },
    divider: tokens.color.border,
  },
  shape: {
    borderRadius: tokens.radius.md,
  },
  typography: {
    fontFamily: tokens.font.family,
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: tokens.radius.sm },
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: { borderRadius: tokens.radius.md },
      },
    },
    MuiTooltip: {
      defaultProps: { arrow: true },
    },
    // On phones, let every dialog use (almost) the whole viewport instead of a
    // squeezed maxWidth card. Desktop sizing (maxWidth="sm|md|lg") is unchanged.
    MuiDialog: {
      styleOverrides: {
        paper: {
          '@media (max-width:600px)': {
            margin: 8,
            width: 'calc(100% - 16px)',
            maxWidth: 'calc(100% - 16px)',
            maxHeight: 'calc(100% - 16px)',
          },
        },
      },
    },
  },
});

export { tokens };
